import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import PromoCodes from './views/promocodes/PromoCodes';
import PromoCodeDetails from './views/promocodes/PromoCodeDetails';
import ItemPrices from './views/itemprices/ItemPrices';
import ItemPriceDetails from './views/itemprices/ItemPriceDetails';
import { ItemGroupType } from '../../api/core/core.types';
import StopSells from './views/stopsells/StopSells';
import StopSellDetails from './views/stopsells/StopSellDetails';
import { UserModel } from '../../api/authentication/authentication.types';
import { AppState } from '../../store/store.types';
import {
  discountRuleViewRoles,
  itemPriceEditRoles,
  itemPriceViewRoles,
  oneWayFeeEditRoles,
  onRequestRuleViewRoles,
  promoCodeEditRoles,
  promoCodeViewRoles,
  ratePlanRoles,
  ratesRequestTestViewRoles,
  stopSellEditRoles,
  stopSellViewRoles
} from '../../api/pricing/pricing.types';
import ConditionalRoute from '../../components/routes/ConditionalRoute';
import RatePlans from './views/rates/RatePlans';
import RatePlanDetails from './views/rates/RatePlanDetails';
import RatesOverview from './views/rates/RatesOverview';
import OneWayFees from './views/onewayfees/OneWayFees';
import OnRequestRules from './views/onerequestrules/OnRequestRules';
import OnRequestRuleDetails from './views/onerequestrules/OnRequestRuleDetails';
import { RatesRequestTest } from './views/ratesrequesttest/RatesRequestTest';
import DiscountRules from './views/discountrules/DiscountRules';
import DiscountRuleDetails from './views/discountrules/DiscountRuleDetails';
import StopSellAuditLog from './views/stopsells/StopSellAuditLog';
import ItemPriceAuditLog from './views/itemprices/ItemPriceAuditLog';
import OnRequestRuleAuditLog from './views/onerequestrules/OnRequestRuleAuditLog';
import DiscountRuleAuditLog from './views/discountrules/DiscountRuleAuditLog';
import PromoCodeAuditLog from './views/promocodes/PromoCodeAuditLog';
import OneWayFeeAuditLog from './views/onewayfees/OneWayFeeAuditLog';

interface RatesEntryProps extends RouteComponentProps {
  user: UserModel;
}

export class RatesEntry extends React.PureComponent<PropsWithChildren<RatesEntryProps>> {

  render() {
    return (
      <>
        {this.props.children}
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/rateplans`}
          render={(routeProps) => <RatePlans {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/overview`}
          render={(routeProps) => <RatesOverview {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/adjustment/:id/create`}
          render={(routeProps: any) => <RatePlanDetails {...routeProps} isNew isAdjustment/>}
        />
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/standardrate/create`}
          render={(routeProps: any) => <RatePlanDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/standardrate/:id/view`}
          render={(routeProps: any) => <RatePlanDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/adjustment/:id/view`}
          render={(routeProps: any) => <RatePlanDetails {...routeProps} isAdjustment/>}
        />
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/standardcopy/:id/view`}
          render={(routeProps: any) => <RatePlanDetails {...routeProps} isCopy/>}
        />
        <ConditionalRoute
          acceptedRoles={ratePlanRoles}
          exact
          path={`${this.props.match.path}/adjustmentcopy/:id/view`}
          render={(routeProps: any) => <RatePlanDetails {...routeProps} isAdjustment isCopy/>}
        />
        <ConditionalRoute
          acceptedRoles={promoCodeViewRoles}
          exact
          path={`${this.props.match.path}/promocodes`}
          render={(routeProps) => <PromoCodes {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={promoCodeEditRoles}
          exact
          path={`${this.props.match.path}/promocodes/create`}
          render={(routeProps: any) => <PromoCodeDetails {...routeProps} isNewCode/>}
        />
        <ConditionalRoute
          acceptedRoles={promoCodeViewRoles}
          exact
          path={`${this.props.match.path}/promocodes/:code/view`}
          render={(routeProps: any) => <PromoCodeDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={promoCodeViewRoles}
          exact
          path={`${this.props.match.path}/promocodes/:id/audit`}
          render={(routeProps: any) => <PromoCodeAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceViewRoles}
          exact
          path={`${this.props.match.path}/extras`}
          render={(routeProps) => <ItemPrices {...routeProps} groupType={ItemGroupType.EXTRA}/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceViewRoles}
          exact
          path={`${this.props.match.path}/protections`}
          render={(routeProps) => <ItemPrices {...routeProps} groupType={ItemGroupType.COVERAGE}/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceViewRoles}
          exact
          path={`${this.props.match.path}/fees`}
          render={(routeProps) => <ItemPrices {...routeProps} groupType={ItemGroupType.FEE}/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceEditRoles}
          exact
          path={`${this.props.match.path}/extras/create`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.EXTRA} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceEditRoles}
          exact
          path={`${this.props.match.path}/extras/copy`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.EXTRA} isCopy/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceViewRoles}
          exact
          path={`${this.props.match.path}/extras/:id/view`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.EXTRA}/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceViewRoles}
          exact
          path={`${this.props.match.path}/protections/:id/view`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.COVERAGE}/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceEditRoles}
          exact
          path={`${this.props.match.path}/protections/create`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.COVERAGE} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceEditRoles}
          exact
          path={`${this.props.match.path}/protections/copy`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.COVERAGE} isCopy/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceEditRoles}
          exact
          path={`${this.props.match.path}/fees/create`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.FEE} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceEditRoles}
          exact
          path={`${this.props.match.path}/fees/copy`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.FEE} isCopy/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceViewRoles}
          exact
          path={`${this.props.match.path}/fees/:id/view`}
          render={(routeProps: any) => <ItemPriceDetails {...routeProps} groupType={ItemGroupType.FEE}/>}
        />
        <ConditionalRoute
          acceptedRoles={itemPriceViewRoles}
          exact
          path={`${this.props.match.path}/itemprices/:id/audit`}
          render={(routeProps: any) => <ItemPriceAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={stopSellViewRoles}
          exact
          path={`${this.props.match.path}/stopsells`}
          render={(routeProps) => <StopSells {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={stopSellViewRoles}
          exact
          path={`${this.props.match.path}/stopsells/:id/audit`}
          render={(routeProps: any) => <StopSellAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={stopSellEditRoles}
          exact
          path={`${this.props.match.path}/stopsells/create`}
          render={(routeProps: any) => <StopSellDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={stopSellViewRoles}
          exact
          path={`${this.props.match.path}/stopsells/:id/view`}
          render={(routeProps: any) => <StopSellDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={oneWayFeeEditRoles}
          exact
          path={`${this.props.match.path}/onewayfees/view`}
          render={(routeProps) => <OneWayFees {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={oneWayFeeEditRoles}
          exact
          path={`${this.props.match.path}/onewayfees/audit`}
          render={(routeProps: any) => <OneWayFeeAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={onRequestRuleViewRoles}
          exact
          path={`${this.props.match.path}/onrequestrules`}
          render={(routeProps) => <OnRequestRules {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={onRequestRuleViewRoles}
          exact
          path={`${this.props.match.path}/onrequestrules/:id/view`}
          render={(routeProps: any) => <OnRequestRuleDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={onRequestRuleViewRoles}
          exact
          path={`${this.props.match.path}/onrequestrules/create`}
          render={(routeProps: any) => <OnRequestRuleDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={onRequestRuleViewRoles}
          exact
          path={`${this.props.match.path}/onrequestrules/:id/audit`}
          render={(routeProps: any) => <OnRequestRuleAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={discountRuleViewRoles}
          exact
          path={`${this.props.match.path}/discountrules`}
          render={(routeProps) => <DiscountRules {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={onRequestRuleViewRoles}
          exact
          path={`${this.props.match.path}/discountrules/:id/view`}
          render={(routeProps: any) => <DiscountRuleDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={onRequestRuleViewRoles}
          exact
          path={`${this.props.match.path}/discountrules/:id/audit`}
          render={(routeProps: any) => <DiscountRuleAuditLog {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={onRequestRuleViewRoles}
          exact
          path={`${this.props.match.path}/discountrules/create`}
          render={(routeProps: any) => <DiscountRuleDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={ratesRequestTestViewRoles}
          exact
          path={`${this.props.match.path}/ratesrequesttest`}
          render={(routeProps: any) => <RatesRequestTest {...routeProps} />}
        />
      </>
    );
  }
}

const subnav = [
  {
    title: 'm2.rate_plans',
    route: '/rates/rateplans',
    roles: ratePlanRoles
  },
  {
    title: 'm2.rates_overview',
    route: '/rates/overview',
    roles: ratePlanRoles
  },
  {
    title: 'm2.stop_sells',
    route: '/rates/stopsells',
    roles: stopSellViewRoles
  },
  {
    title: 'm2.discount_rules',
    route: '/rates/discountrules',
    roles: discountRuleViewRoles
  },
  {
    title: 'm2.on_request_rules',
    route: '/rates/onrequestrules',
    roles: onRequestRuleViewRoles
  },
  {
    title: 'm2.promo_codes',
    route: '/rates/promocodes',
    roles: promoCodeViewRoles
  },
  {
    title: 'm2.extras',
    route: '/rates/extras',
    roles: itemPriceViewRoles
  },
  {
    title: 'm2.fees',
    route: '/rates/fees',
    roles: itemPriceViewRoles
  },
  {
    title: 'm2.protections',
    route: '/rates/protections',
    roles: itemPriceViewRoles
  },
  {
    title: 'm2.one_way_fees',
    route: '/rates/onewayfees/view',
    roles: oneWayFeeEditRoles
  },
  {
    title: 'm2.rates_request_test',
    route: '/rates/ratesrequesttest',
    roles: ratesRequestTestViewRoles
  }
];

const mapStateToProps = (state: AppState) => ({
  user: state.authentication.user
});

const ratesEntry = connect(mapStateToProps, null)(RatesEntry);

export default {
  ratesEntry,
  subnav
};
